import {SmartComponent} from "smart-component-js";
import Swiper, {Navigation, Pagination} from "swiper";

class HighlightedProductsCarouselComponent extends SmartComponent {

    constructor(element, parentComponent, params) {
        super(element, parentComponent, params);
        this.element = element;
        this.swiper = this.element.querySelector('.swiper');
        this.init();
    }

    initSwiper() {
        new Swiper(this.swiper, {
            slidesPerView: 1.1,
            spaceBetween: 20,
            breakpoints: {
                768: {
                    slidesPerView: 2
                },
            },
            modules: [Navigation, Pagination],
            pagination: {
                el: '.swiper-pagination',
                clickable: true,
                type: 'bullets'
            },
            navigation: {
                nextEl: '.swiper-button-next',
                prevEl: '.swiper-button-prev'
            },
        });
    }

    init() {
        this.initSwiper();
    }
}

export default HighlightedProductsCarouselComponent;